import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import MessengerSettings from '../components/settings/MessengerSettings';

const MessengerSettingsPage = () => {
  return (
    <div className="space-y-6" data-testid="messenger-settings-page">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/settings">
            <ArrowLeft className="w-5 h-5" />
          </Link>
        </Button>
        <div className="flex items-center gap-3">
          <MessageCircle className="w-8 h-8 text-primary" />
          <div>
            <h1 className="text-2xl font-bold">HELP Messages Settings</h1>
            <p className="text-muted-foreground">Configure business hours, auto-replies, and AI summaries</p>
          </div>
        </div>
      </div>

      <MessengerSettings />
    </div>
  );
};

export default MessengerSettingsPage;
